import React, {useEffect, useState} from 'react';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
    Breadcrumbs,
    Container,
    Typography,
    Grid,
    FilledInput,
    TextField,
    FormGroup,
    FormControlLabel, Switch
} from "@mui/material";
import {getCompany, isDealerSite, isWidget, newRequestApi, registerFindTrip, requestApi} from "../../utils/utils";
import {Theme, useTheme} from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import Prism from 'prismjs';
// import 'prismjs/components/prism-javascript';
import {useAuthUser} from "react-auth-kit";
import PrimaryButton from "../../components/Common/PrimaryButton";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

// const locationValues = [
//     {name: 'Nautilus Explorer', value: '1'},
//     {name: 'Nautilus Belle Amie', value: '3'},
//     {name: 'Nautilus Under Sea', value: '4'},
//     {name: 'Nautilus Gallant Lady', value: '5'},
//     {name: 'Nautilus Westerly', value: '6'},
//     {name: 'San Ignacio Glamping', value: '7'},
//     {name: 'San Ignacio Luxury', value: '8'},
//     {name: 'Espiritu Santo Eco Camp', value: '9'},
//     {name: 'Kayaking', value: '10'},
//     {name: 'Gallant Lady and Luxury Camp', value: '11'},
//     {name: 'San Ignacio Camp Timo', value: '12'},
//     {name: 'Overlanding', value: '13'},
//     {name: 'Mango Wind', value: '15'},
// ];
// const DestinationValues = [
//     {name: 'Socorro Combo Expeditions', value: '3'},
//     {name: 'Socorro Giant Mantas, Dolphins & 11 Species of Sharks', value: '5'},
//     {name: 'Sea of Cortez 5 Nights Get Aways', value: '12'},
//     {name: 'Mexico Sardine Run / Magdalena Bay', value: '22'},
//     {name: 'San Ignacio Lagoon Gray Whales', value: '20'},
//     {name: 'Espiritu Santo', value: '21'},
//     {name: 'Orcas & Mobulas in the Sea of Cortez', value: '27'},
//     {name: 'Baja Ultimate Whales', value: '29'},
//     {name: 'Ultimate Whale Sharks in the Sea of Cortez', value: '32'},
//     {name: 'Summer adventures and whale sharks', value: '37'},
//     {name: 'Luxury Liveaboard Kayaking', value: '42'},
//     {name: 'Loreto Great Circle / La Paz', value: '47'},
//     {name: 'Cocos Island of the Sharks', value: '23'},
//     {name: 'Ocean & Rainforest Adventures', value: '25'},
//     {name: 'Swimming', value: '52'},
//     {name: 'Special Expeditions', value: '57'},
//     {name: 'San Ignacio 7 days - 6 nights', value: '62'},
//     {name: 'Overlanding', value: '67'},
// ];
const GetWidgetApiKey = () => {
    const theme = useTheme();
    const [location, setLocation] = useState([]);
    const [locationValues, setLocationValues] = useState([])
    const [adventureValues, setAdventureValues] = useState([])
    const [destinationValues, setDestinationValues] = useState([])
    const [destination, setDestination] = useState([]);
    const [showOnlyAvailableTrips, setShowOnlyAvailableTrips] = useState(false);
    const [showOnlyDealerTrips, setShowOnlyDealerTrips] = useState(false);
    const [showFilters, setShowFilters] = useState(true);
    const [generatedCode, setGeneratedCode] = useState('');
    const [apiKey, setApiKey] = useState('');
    const auth = useAuthUser();

    useEffect(() => {
        Prism.highlightAll(); // Inicializar Prism para resaltar el código
    }, [generatedCode]);
    useEffect(async () => {
        const {data} = await requestApi(`/get-dealer-apikey/${auth().id}`);
        if (data.status === 'success') {
            // console.log(data.data.apikey);
            setApiKey(data.data.apikey);
        }
        // Inicializar Prism para resaltar el código
    }, []);
    useEffect(async () => {
        const fetchData = async () => {
            await fetchDestinations();
            // await fetchAdventures();
            await fetchShips();
        };

        await fetchData();
    }, []);

    const fetchDestinations = async (preloader = false) => {
        const {data} = await newRequestApi("get-destination-list", "GET", null, null, preloader);
        if (data.status === "success") {
            setDestinationValues(data.data);
        }
    };

    const fetchAdventures = async (preloader = false) => {
        const {data} = await newRequestApi('get-adventures', "GET", null, null, preloader);
        if (data.status === 'success')
            setAdventureValues(data.data);
    };

    const fetchShips = async (preloader = false) => {
        const {data} = await newRequestApi("get-ships", "GET", null, null, preloader);
        if (data.status === "success") setLocationValues(data.data);
    };

    function getStyles(name, locationValues, theme) {
        return {
            fontWeight:
                location.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    }

    const handleLocation = (event) => {
        const {
            target: {value},
        } = event;
        setLocation(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    const handleDestination = (event) => {
        const {
            target: {value},
        } = event;
        setDestination(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const toggleShowFilters = (event) =>{
        setShowFilters(event.target.checked);
    };
    const toggleShowAvailable = (event) =>{
        setShowOnlyAvailableTrips(event.target.checked);
    };
    const toggleShowOnlyDealerTrips = (event) =>{
        setShowOnlyDealerTrips(event.target.checked);
    };
    const handleGenerateCode = (event) => {
        event.preventDefault();


        if (apiKey !== '') {
            let url = `https://widget.nautilusdive.com/plugin.js?apiKey=${apiKey}`;
            if (location.length > 0) {
                url += `&location=${location.join(',')}`;
            }
            if (destination.length > 0) {
                url += `&destination=${destination.join(',')}`;
            }
            if(showOnlyAvailableTrips)
                url +=`&hideUnavailable=1`;
            if(showOnlyDealerTrips)
                url +=`&onlyDealerTrips=1`;
            if(!showFilters)
                url +=`&showFilters=0`;
            setGeneratedCode(
                `<div id="nautilusTrips"></div>\n<script type="text/javascript" src="${url}"></script>`
            );
        }
    };
    return (
        <>
            <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Typography color="text.primary">
                        Widget Integration
                    </Typography>
                </Breadcrumbs>
            </GuestBar>
            <Container style={{marginBottom: '50px'}} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                {isDealerSite() && <Grid container sx={{px: {xs: '1.6rem', lg: '0'}}}>
                    <h2>Get your Widget code</h2>
                    <Grid container spacing={3}>
                        <Grid item xs={6} md={3}>
                            <TextField sx={{m: 1, width: 300}} id="outlined-basic" name="apiKey" value={apiKey}
                                       label="API Key" variant="outlined" fullWidth/>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormControl sx={{m: 1, width: 300}}>
                                <InputLabel id="locationLabel" htmlFor="locationSelect">Location</InputLabel>
                                <Select
                                    labelId="locationLabel"
                                    id="locationSelect"
                                    multiple
                                    value={location}
                                    onChange={handleLocation}
                                    input={<OutlinedInput label="location"/>}
                                    MenuProps={MenuProps}
                                >
                                    {locationValues.map(s => <MenuItem key={s.id} value={s.id} style={getStyles(s.value, location, theme)}>{s.value}</MenuItem>)}
                                </Select>
                                <Typography> Leave
                                    unselected for
                                    all
                                </Typography>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormControl sx={{m: 1, width: 300}}>
                                <InputLabel id="destinationLabel" htmlFor="destinationSelect">Destination</InputLabel>
                                <Select
                                    labelId="destinationLabel"
                                    id="destinationSelect"
                                    multiple
                                    value={destination}
                                    onChange={handleDestination}
                                    input={<OutlinedInput label="destination"/>}
                                    MenuProps={MenuProps}
                                >
                                    {destinationValues.map(d =>
                                            d['destinations'].length > 0 && d['destinations'].map(dd => (
                                                <MenuItem style={getStyles(dd.class, destination, theme)} key={dd.tripClassId}
                                                          value={dd['tripClassId']}>
                                                    {dd.class}
                                                </MenuItem>
                                            ))
                                    )}
                                </Select>
                                <Typography> Leave
                                    unselected for
                                    all
                                </Typography>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormGroup style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            size={'medium'}
                                            color={'primary'}
                                            checked={showOnlyDealerTrips}
                                            value={showOnlyDealerTrips}
                                            name="onlyDealerTrips"
                                            onChange={toggleShowOnlyDealerTrips}
                                        />
                                    }
                                    label=""
                                />
                                <span style={{fontSize: '1.2rem'}}>Show My Trips Only</span>
                            </FormGroup>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormGroup style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            size={'medium'}
                                            color={'primary'}
                                            checked={showFilters}
                                            value={showFilters}
                                            name="showFilters"
                                            onChange={toggleShowFilters}
                                        />
                                    }
                                    label=""
                                />
                                <span style={{fontSize: '1.2rem'}}>Show controls</span>
                            </FormGroup>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormGroup style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            size={'medium'}
                                            color={'primary'}
                                            checked={showOnlyAvailableTrips}
                                            value={showOnlyAvailableTrips}
                                            name="showAvailables"
                                            onChange={toggleShowAvailable}
                                        />
                                    }
                                    label=""
                                />
                                <span style={{fontSize: '1.2rem'}}>Show only trips with availability</span>
                            </FormGroup>
                        </Grid>
                        <Grid item xs={6} md={12}>
                            <PrimaryButton
                                sx={{mx: {xs: '1.6rem', lg: '0'}, marginTop: '20px', width: '200px'}}
                                onClick={handleGenerateCode}>Generate URL</PrimaryButton>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <h2>Code for your site:</h2>
                            <pre>
                                <code style={{border:'none'}} id="codeOutput" className="language-html">{generatedCode}</code>
                            </pre>
                        </Grid>
                    </Grid>
                </Grid>}
            </Container>
        </>

    );
};

export default GetWidgetApiKey;
